import { useState } from 'react'
import DatePicker from 'react-datepicker'
import { isSameMonth, startOfDay } from 'date-fns'

import './datepicker.css'
import { DatepickerProps } from './types'

import ChevronRight from '@sylveraio/untitled-ui-icons-react/build/esm/ChevronRight'
import ChevronLeft from '@sylveraio/untitled-ui-icons-react/build/esm/ChevronLeft'

export const Datepicker = ({ handleChange, placeholder }: DatepickerProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null)
  const [currentMonth, setCurrentMonth] = useState<Date>(new Date())
  const today = startOfDay(new Date())

  const handleMonthChange = (date: Date) => {
    setCurrentMonth(date)
  }

  const handleOnChange = (selectedDate: Date | null) => {
    handleChange(selectedDate)
    setSelectedDate(selectedDate)
  }

  const handleCalendarOpen = () => {
    setCurrentMonth(selectedDate || new Date())
  }

  return (
    <div>
      <DatePicker
        selected={selectedDate}
        onChange={handleOnChange}
        dateFormat="dd MMMM yyyy"
        onMonthChange={handleMonthChange}
        onCalendarOpen={handleCalendarOpen}
        dayClassName={(date) =>
          isSameMonth(date, currentMonth) ? '' : '!text-subtle'
        }
        placeholderText={placeholder}
        minDate={today}
        className="h-9 px-2 rounded-lg border border-default text-sm text-default outline-0 ring-content-action-subtle ring-offset-2 placeholder:text-subtle hover:border-default-hover hover:bg-high-hover focus-visible:border-content-action-default focus-visible:ring-4 w-full"
        nextMonthButtonLabel={<ChevronRight height={20} width={20} />}
        previousMonthButtonLabel={<ChevronLeft height={20} width={20} />}
        showPopperArrow={false}
      />
    </div>
  )
}
